import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { BodyL, BrandM, BrandXXL } from 'atoms/typography';
import { Img } from 'atoms/ui/Img';
import { useIsLaptop } from 'hooks/device/useIsLaptop';
import { laptopAndAbove } from 'style/mediaQuery';

import mobileRewards from './assets/mobileRewards.webp';
import webBackground from './assets/webBackground.webp';

const Root = styled(Vertical)`
  padding: var(--double-unit);
  @media ${laptopAndAbove} {
    flex-direction: row;
    gap: calc(var(--unit) * 10);
    padding: calc(var(--unit) * 15) calc(var(--unit) * 10);
    align-items: flex-start;
    justify-content: flex-end;
    min-height: calc(var(--unit) * 125);
    background-image: url(${webBackground});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

const ImageContainer = styled.div`
  @media ${laptopAndAbove} {
    width: 50%;
  }
`;

const TextContainer = styled(Vertical).attrs({
  gap: 6,
  center: true,
})`
  @media ${laptopAndAbove} {
    width: 50%;
    padding: 100px 0;
  }
`;

// const StyledImg = styled(Img)`
//   position: absolute;
// `;

export const WinRewards = () => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <Root>
      {/* {!!isLaptopAndAbove && <StyledImg src={webBackground} />} */}
      <TextContainer>
        <Vertical gap={4}>
          <Vertical gap={2}>
            <BrandM uppercase color="var(--c-limited)">
              <FormattedMessage
                id="HowToPlay.WinRewards.eyebrow"
                defaultMessage="How to win rewards"
              />
            </BrandM>
            <BrandXXL uppercase>
              <FormattedMessage
                id="HowToPlay.WinRewards.title"
                defaultMessage="Rewards all season long"
              />
            </BrandXXL>
          </Vertical>
          <BodyL>
            <FormattedMessage
              id="HowToPlay.WinRewards.description"
              defaultMessage="Sorare competitions offer new rewards throughout the season,
so <b>it's never too late to join and win.</b>"
              values={{
                b: chunks => <strong>{chunks}</strong>,
              }}
            />
          </BodyL>
        </Vertical>
      </TextContainer>
      {!isLaptopAndAbove && (
        <ImageContainer>
          <Img src={mobileRewards} width={705} height={1127} alt="" />
        </ImageContainer>
      )}
    </Root>
  );
};
